import { useMemo } from 'react';
import { useFilterOptions } from '../stores/useFilterOptions';

export const useFilterOptionsData = () => {
  const data = useFilterOptions((state) => state.data);

  return useMemo(
    () => ({
      data,
      hasData: !!data,
    }),
    [data],
  );
};
